<script>
import { Pie } from "vue-chartjs/legacy";
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
    LinearScale,
} from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
    LinearScale,
    // ChartDataLabels
);

export default {
    extends: Pie,
    props: {
        chartData: {
            type: Object,
            required: true,
            default: () => ({}),
        },
        chartOptions: {
            type: Object,
            default: () => ({
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem) {
                                return (
                                    tooltipItem.label +
                                    ": " +
                                    tooltipItem.raw +
                                    " units"
                                );
                            },
                        },
                    },
                    // datalabels: {
                    //     anchor: "center",
                    //     align: "center",
                    //     formatter: (value, context) => {
                    //         return (
                    //             context.chart.data.labels[context.dataIndex] +
                    //             ": " +
                    //             value
                    //         );
                    //     },
                    // },
                },
            }),
        },
    },
    watch: {
        chartData: {
            handler(newData) {
                if (this.chartInstance) {
                    this.chartInstance.data = newData;
                    this.chartInstance.update();
                }
            },
            deep: true,
        },
        chartOptions: {
            handler(newOptions) {
                if (this.chartInstance) {
                    this.chartInstance.options = newOptions;
                    this.chartInstance.update();
                }
            },
            deep: true,
        },
    },
    methods: {
        renderChart() {
            if (this.chartInstance) {
                this.chartInstance.destroy();
            }
            this.chartInstance = new ChartJS(this.$refs.canvas, {
                type: "pie",
                data: this.chartData,
                options: this.chartOptions,
            });
        },
    },
    mounted() {
        this.renderChart();
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.destroy();
        }
    },
};
</script>

<template>
    <div>
        <canvas ref="canvas"></canvas>
    </div>
</template>

<style scoped>
canvas {
    width: 100%;
    height: 400px;
}
</style>
